import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
/**
 * @memberOf Qualifiers.AspectRatio
 * @extends {SDK.QualifierValue}
 */
export class AspectRatioQualifierValue extends QualifierValue {
}
